import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';
import HelpDrawer from './HelpDrawer';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: 'faHome' },
    { name: 'Bridges', href: '/bridges', icon: 'faBuilding' },
    { name: 'Simulation Engine', href: '/enhanced-simulation-results', icon: 'faChartLine' },
    { name: 'New Simulation Engine', href: '/new-simulation-engine', icon: 'faChartLine' },
    { name: 'Repair Projects', href: '/repair-projects', icon: 'faWrench' },
    { 
      name: 'Masters Management', 
      icon: 'faClipboardList',
      children: [
        // Step 1: Foundation Masters (Environmental & Damage Assessment)
        { name: 'Corrosion & Damage', href: '/masters/corrosion-damage', icon: 'faShieldAlt' },
        
        // Step 2: Repair Process Definition
        { name: 'Repair Rules', href: '/masters/repair-rules', icon: 'faCogs' },
        { name: 'Decay Trigger Config', href: '/masters/decay-trigger-config', icon: 'faPercent' },
        { name: 'New Simulation Triggers', href: '/masters/new-simulation-triggers', icon: 'faPercent' },
        { name: 'Cycle Limits', href: '/masters/maintenance-cycle-limits', icon: 'faClock' },
        
        // Step 3: Cost Components
        { name: 'Surface Prep Methods', href: '/masters/surface-prep-methods', icon: 'faWrench' },
        { name: 'Washing Costs', href: '/masters/washing-costs', icon: 'faSprayCan' },
        { name: 'Materials Master', href: '/masters/materials-master', icon: 'faCube' },
        { name: 'Field Application Labor', href: '/masters/field-application-labor', icon: 'faWrench' },
        { name: 'Labor by Coat Type', href: '/masters/labor-by-coat', icon: 'faWrench' },
      ]
    },
    ...(user?.role === 'admin' ? [{ name: 'User Management', href: '/users', icon: 'faUsers' }] : []),
    { name: 'Help & Documentation', href: '/help', icon: 'faQuestionCircle' },
    { name: 'Settings', href: '/settings', icon: 'faCog' },
  ];

  const userNavigation = [
    { name: 'Your Profile', href: '/profile' },
    { name: 'Settings', href: '/settings' },
  ];

  return (
    <div className="h-screen flex overflow-hidden bg-gray-100">
      {/* Sidebar */}
      <Sidebar
        navigation={navigation}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        currentPath={location.pathname}
      />

      {/* Main content */}
      <div className="flex-1 overflow-auto focus:outline-none">
        {/* Header */}
        <Header
          user={user}
          userNavigation={userNavigation}
          setSidebarOpen={setSidebarOpen}
        />

        {/* Page content */}
        <main className="flex-1 relative z-0 overflow-y-auto py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <Outlet />
          </div>
        </main>
      </div>

      <HelpDrawer />
    </div>
  );
};

export default Layout; 